import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { calFetch, clearCalSession, getCalPerson, getCalToken, saveCalSession } from "./calApi";

const CalAuthCtx = createContext(null);

export function CalAuthProvider({ children }) {
  const [token, setToken] = useState(getCalToken());
  const [person, setPerson] = useState(getCalPerson());

  useEffect(() => {
    if (!getCalToken()) return;
    calFetch("/cal/me").then((r) => {
      const p = { id: r.person.id, name: r.person.name, nickname: r.person.nickname || "", branch: r.person.branch || "", is_admin: !!r.is_admin };
      saveCalSession(getCalToken(), p);
      setPerson(p);
    }).catch((e) => { if (e.status === 401) { clearCalSession(); setToken(""); setPerson(null); } });
  }, []);

  const enter = useCallback(async (mode, personId, password) => {
    const r = await calFetch(mode === "register" ? "/cal/register" : "/cal/login", {
      method: "POST", body: { person_id: personId, password },
    });
    saveCalSession(r.token, r.person);
    setToken(r.token);
    setPerson(r.person);
    return r.person;
  }, []);

  const logout = useCallback(async () => {
    try { await calFetch("/cal/logout", { method: "POST" }); } catch { /* sesión ya muerta */ }
    clearCalSession();
    setToken("");
    setPerson(null);
  }, []);

  const expire = useCallback(() => { clearCalSession(); setToken(""); setPerson(null); }, []);

  return (
    <CalAuthCtx.Provider value={{ token, person, enter, logout, expire }}>
      {children}
    </CalAuthCtx.Provider>
  );
}

export const useCalAuth = () => useContext(CalAuthCtx);
